(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.directive('vvDelayedSrc', function(vv, vvService) {
    return {
      restrict: 'A',
      scope: {
        vvDelayedSrc: '@'
      },
      link: function(scope, element, attrs) {
        if (vv.feature.disableDelayedLoad) {
          scope.$watch('vvDelayedSrc', function() {
            element.attr('src', vv.adjustProtocol(scope.vvDelayedSrc));
          });
        } else {
          vvService.windowLoad(function() {
            scope.$watch('vvDelayedSrc', function() {
              element.attr('src', vv.adjustProtocol(scope.vvDelayedSrc));
            });
          });
        }
      }
    };
  });
})(window, window.angular);
